module.exports = __webpack_public_path__ + "img/headSculpture2.5ca4ba37.png";